import { render, staticRenderFns } from "./ImportNewItem.vue?vue&type=template&id=a3a079b8&"
import script from "./ImportNewItem.vue?vue&type=script&lang=js&"
export * from "./ImportNewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports